<!-- 批量处理异常 -->
<template>
    <modal :visible.sync="isShowDialog" :title="$t('integration.batch_handle')" width="500px" @close="close">
        <div style="padding: 10px 20px;">
            <HandleEx ref="handleEx" :detail="detail"></HandleEx>
        </div>
        <template #footer>
            <el-button type="primary" @click="save">{{ $t('public.btn_confirm') }}</el-button>
            <el-button type="primary" @click="close">{{ $t('public.btn_close') }}</el-button>
        </template>
    </modal>
</template>

<script>
import HandleEx from '@/pages/abnormal/component/HandleExDia/HandleEx.vue';
import { exHandle } from "@/api/modules/abnormal";

export default {
    name: 'BatchHandleDialog',
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        exIds: {
            type: Array,
            default: () => []
        },
        detail: {
            type: Array,
            default: () => []
        }
    },
    components: {
        HandleEx
    },
    computed: {
        isShowDialog: {
            get() {
                return this.isShow
            },
            set(val) {
                this.$emit('update:isShow', val)
            }
        }
    },
    methods: {
        async save() {
            try {
                const data = await this.$refs['handleEx'].getData();
                exHandle({
                    exIds: this.exIds,
                    process: { ...data }
                }).then(({ result }) => {
                    this.$refs.handleEx.handleResult(result, () => {
                        this.$refs.handleEx.reset();
                        this.$emit('close');
                        this.$parent.getList();
                    });
                })
            } catch (e) {
                // 校验失败，不关闭浮动框
            }
        },
        close() {
            if (this.$refs.handleEx) {
                this.$refs.handleEx.reset();
            }
            this.$emit('close');
        }
    }
}
</script>
